import { BookOpen, FileText } from 'lucide-react'

import { defineArea, defineModule } from '@/lib/module-routes'
import { CONTENT_PERMISSIONS } from '@/lib/permissions'

import { entityContentRoute, entityContentEditorRoute, entityContentPreviewRoute, entityContentVersionsRoute, entityDocsDocumentRoute, entityDocsRoute } from './routes'

const docsArea = defineArea({ id: 'docs', label: 'Docs sections', product: 'docs', gated: true })
const contentArea = defineArea({ id: 'content', label: 'Content sections', product: 'content', gated: true })

declare module '@/lib/module-routes' {
  interface Areas {
    docs: typeof docsArea
    content: typeof contentArea
  }
}

export const contentModule = defineModule({
  routes: [
    entityDocsRoute,
    entityDocsDocumentRoute,
    entityContentRoute,
    entityContentEditorRoute,
    entityContentPreviewRoute,
    entityContentVersionsRoute,
  ],
  products: [
    {
      id: 'docs',
      label: 'Docs',
      description: 'Published help and guidance',
      icon: BookOpen,
      order: 40,
      routes: [entityDocsRoute, entityDocsDocumentRoute],
    },
    {
      id: 'content',
      label: 'Content',
      description: 'Author and manage articles',
      icon: FileText,
      order: 50,
      routes: [entityContentRoute, entityContentEditorRoute, entityContentPreviewRoute, entityContentVersionsRoute],
    },
  ],
  areas: [docsArea, contentArea],
  sections: {
    docs: [{ id: 'docs', label: 'Docs', order: 10 }],
    content: [{ id: 'content', label: 'Content', order: 10 }],
  },
  navigation: {
    docs: [
      {
        to: '/$entityId/docs',
        label: 'Docs',
        icon: BookOpen,
        permission: CONTENT_PERMISSIONS.read,
        section: 'docs',
        order: 10,
      },
    ],
    content: [
      {
        to: '/$entityId/content',
        label: 'Content',
        icon: FileText,
        permission: CONTENT_PERMISSIONS.read,
        section: 'content',
        order: 10,
      },
    ],
  },
})
